import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ApiError, MessageService } from '../../../../../core';
import { PedidoFilter } from '../../../../pedido/filter/pedido-filter';
import { PedidoSearch } from '../../../../pedido/pedido-search';
import { PedidoSearchOrderBy } from '../../../../pedido/pedido-search-orderby';
import { PedidoSearchHttpService } from '../../../../pedido/services';
import { pedidoNaoLiberado } from '../../../../pedido/status';
import { CampanhaFilter } from '../../filter';
import { referenciaDataEmissao } from '../../../../pedido/referencia-data';


@Component({
    selector: 'sgt-campanha-pedido-nao-liberado-pipeline-card',
    templateUrl: './campanha-pedido-nao-liberado-pipeline-card.component.html',
    styleUrls: ['./campanha-pedido-nao-liberado-pipeline-card.component.less']
})
export class CampanhaPedidoNaoLiberadoPipelineCardComponent {
    @Input() idCampanha: number;
    @Input() filter: CampanhaFilter;

    isLoading = false;
    isLoaded = false;
    pedidos: PedidoSearch[];

    // Collapse
    @ViewChild('collapse') collapse: ElementRef;
    isCollapseOpened = false;

    constructor(private messageService: MessageService,
                private pedidoSearchHttpService: PedidoSearchHttpService) { }


    ngAfterViewInit() {
        // Registrando evento ao abrir o collapse
        jQuery(this.collapse?.nativeElement).on('show.bs.collapse', () => {
            this.isCollapseOpened = true;
        });
        // Registrando evento ao fechar o collapse
        jQuery(this.collapse?.nativeElement).on('hidden.bs.collapse', () => {
            this.isCollapseOpened = false;
        });
    }

    /** Abre/Fecha o collapse */
    toggleCollapse() {
        if (!this.isCollapseOpened) {
            this.openCollapse();
        } else {
            this.closeCollpase();
        }
    }

    /** Abre o collapse */
    private openCollapse() {
        // Pesquisando os itens do pedido
        if (!this.isLoaded) {
            this.search();
        }

        (jQuery(this.collapse?.nativeElement) as any).collapse('show');
    }

    /** Fecha o collapse */
    private closeCollpase() {
        (jQuery(this.collapse?.nativeElement) as any).collapse('hide');
    }

    /** Cria o filtro dos pedido */
    private createPedidoFilter(): PedidoFilter {
        const pedidoFilter = new PedidoFilter(referenciaDataEmissao);

        // Campanha
        if (this.idCampanha > 0) {
            pedidoFilter.idsCampanhas = [this.idCampanha];
        }

        // Periodicidade da vigência da campanha
        pedidoFilter.periodicidadeVigencia = this.filter.periodicidadeVigencia;
        pedidoFilter.dataInicioVigencia = this.filter.dataInicioVigencia;
        pedidoFilter.dataTerminoVigencia = this.filter.dataTerminoVigencia;
        pedidoFilter.dataInicioVigenciaPeriodo = this.filter.dataInicioVigenciaPeriodo;
        pedidoFilter.dataTerminoVigenciaPeriodo = this.filter.dataTerminoVigenciaPeriodo;
        pedidoFilter.mesVigencia = this.filter.mesVigencia;
        pedidoFilter.trimestreVigencia = this.filter.trimestreVigencia;
        pedidoFilter.semestreVigencia = this.filter.semestreVigencia;
        pedidoFilter.anoVigencia = this.filter.anoVigencia;

        // Status Não Liberado
        pedidoFilter.status = [pedidoNaoLiberado.id];

        // Representantes
        pedidoFilter.idsRepresentantes = this.filter.idsRepresentantes;

        // Pessoas (Cliente promoção)
        pedidoFilter.idPessoaCampanha = this.filter.idPessoa;

        return pedidoFilter;
    }

    /** Pesquisa os pedidos não liberados vinculados à campanha */
    private search() {
        if (!this.idCampanha) {
            return
        }

        this.isLoading = true;
        this.isLoaded = false;
        const pedidoFilter = this.createPedidoFilter()
        this.pedidoSearchHttpService.search(null, pedidoFilter, PedidoSearchOrderBy.DataEmissao, 'desc', -1, -1)
            .subscribe(
                pedidos => {
                    this.pedidos = pedidos;
                    this.isLoading = false;
                    this.isLoaded = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os pedidos não liberados da campanha', error);
                    this.isLoading = false;
                }
            );
    }

    ngOnDestroy() {
        // Removendo evento ao abrir o collapse
        jQuery(this.collapse?.nativeElement).off('show.bs.collapse');
        // Removendo evento ao fechar o collapse
        jQuery(this.collapse?.nativeElement).off('hidden.bs.collapse');
    }
}
